import { Pipe, PipeTransform } from '@angular/core';

import { isWindpowerStation } from '../constants/constants';

@Pipe({ name: 'isWindpowerStation' })
export class IsWindpowerStationPipe implements PipeTransform {
  transform(stationId: number) {
    return isWindpowerStation(stationId);
  }
}
